import QuestionnairesIncludedQuestionsForm from 'src/javascripts/components/questionnaires/QuestionnairesIncludedQuestionsForm';

export default class QuestionnairesIncludedQuestionsNew {

  constructor() {}

  render() {

  	QuestionnairesIncludedQuestionsForm();

  }

}